import { useEffect, useMemo } from 'react';
import { MapContainer, Marker, TileLayer, useMap, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import type { LatLng } from '../lib/geo';

// Fix default marker icon paths for Vite bundling
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

const defaultIcon = L.icon({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIcon2x,
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

function MapEvents({ onChange }: { onChange: (ll: LatLng) => void }) {
  useMapEvents({
    click(e) {
      onChange({ lat: e.latlng.lat, lng: e.latlng.lng });
    },
  });
  return null;
}

function FlyTo({ pos }: { pos: LatLng }) {
  const map = useMap();
  useEffect(() => {
    map.setView([pos.lat, pos.lng], map.getZoom() < 16 ? 17 : map.getZoom(), { animate: true });
  }, [pos.lat, pos.lng, map]);
  return null;
}

export function MapPicker({
  value,
  onChange,
}: {
  value: LatLng;
  onChange: (ll: LatLng) => void;
}) {
  const center = useMemo<[number, number]>(() => [value.lat, value.lng], [value.lat, value.lng]);
  return (
    <div className="overflow-hidden rounded-2xl ring-1 ring-gray-200">
      <MapContainer center={center} zoom={17} style={{ height: 260, width: '100%' }}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker
          position={center}
          icon={defaultIcon}
          draggable
          eventHandlers={{
            dragend: (e) => {
              const ll = (e.target as L.Marker).getLatLng();
              onChange({ lat: ll.lat, lng: ll.lng });
            },
          }}
        />
        <MapEvents onChange={onChange} />
        <FlyTo pos={value} />
      </MapContainer>
      <p className="bg-gray-50 px-3 py-2 text-xs text-gray-500">
        แตะแผนที่หรือลากหมุดเพื่อปรับตำแหน่ง • {value.lat.toFixed(5)}, {value.lng.toFixed(5)}
      </p>
    </div>
  );
}
